import './index.scss'
import {setVisibilityOfPartnersSection} from '../components/action-section/action-section'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setVisibilityOfPartnersSection)
} else {
  setVisibilityOfPartnersSection()
}



// WEBPACK FOOTER //
// ./src/bundle/index.js